import React, { PropsWithChildren, useContext } from "react";

import { ValueRecord } from "../../types";
import { useAffinityFormReturn } from "../useAffinityFormControls";

export const InnerFormContext = React.createContext<Maybe<useAffinityFormReturn>>(null);
export const WithInnerFormContext = <DATA extends ValueRecord = ValueRecord>({
  formContext,
  children,
}: PropsWithChildren<{ formContext: React.Context<Maybe<useAffinityFormReturn<DATA>>> }>): React.ReactElement => {
  const formContextFields = useContext(formContext);
  return (
    <InnerFormContext.Provider value={formContextFields as Maybe<useAffinityFormReturn>}>
      {children}
    </InnerFormContext.Provider>
  );
};
